import { createStoreSelectors } from '@cocoonspace/shared/utils/create-store-selectors'
import { create } from 'zustand'

export type SidebarStep = 'start' | 'date' | 'nbPeople'

export interface FormData {
	day: string
	nbPeople: number
}

interface DeskBookingState {
	sidebarStep: SidebarStep
	setSidebarStep: (sidebarStep: SidebarStep) => void

	formData: FormData
	setFormData: (formData: Partial<FormData>) => void
}

const useDeskBookingStoreBase = create<DeskBookingState>()((set) => ({
	sidebarStep: 'start',
	setSidebarStep: (sidebarStep) => set({ sidebarStep }),

	formData: {
		day: '',
		nbPeople: 1,
	},
	setFormData: (formData) =>
		set((state) => ({
			formData: { ...state.formData, ...formData },
		})),
}))

export const useDeskBookingStore = createStoreSelectors(useDeskBookingStoreBase)
